export const labelColor = "#808080";
export const titleColor = "#00bcd4";
export const redColor = "#ff0000";
export const darkRed = "#b91c1c";
export const white = "#fff";
export const DarkBlue = "#2196F3";
export const cyanBlue = "#2196f3";
export const systemColor = "#34a9f4";
export const blackColor = "#000";
export const checkboxColor = "#1976d2";
export const greyColor = "#808080";
export const darkgreyColor = "#5a5a5a";
export const yellowishBrownColor = "#E97451";
export const checkedColor = "#d4b69e";
export const DimGrayColor = "#666666";
export const LightYellowColor = "#F4D03F";
export const LightGreenColor = "#58D68D";
export const checkboxShadowColor = "#acacac";
export const yellowColor = "#fbff00";
export const figmaTitleColor = "#004969";
export const lightVioletColor = "#BA92F1";
export const smoothGreenColor = "#BDFB7F";
export const primary = "#004969";
export const vividGreen = "#66ff33";
export const pastelPink = "#FAA0A0";
export const lightGreen = "#D6F20F";
export const lightSkyBlue = "#79E6FF";
export const brownishRed = "#AF716D";
export const periwinkleblue = "#7A8DFF";
export const lightOrange = "#FDD260";
export const skyBlueNew = "#03a9f4";
export const offWhiteColor = " #f4f6fa";
export const lightPinkColor = "#ed8e98";
export const aliceBlueColor = "#f7f8fa";
export const strongRedColor = "#d32f2f";
export const blackPantherColor = "#424242";
export const stoneColdGrayColor = "#555";
export const redShadowColor = "#b71c1c";
export const warmPinkColor = "#ffe6e5";
export const SeashellColor = "#fff1f0";
export const melonColor = "#ffcccb";
export const darkGrayColor = "#242222ff";
export const violetShadeColor = "#667eea";
export const grayShadeColor = "#0f0f0fff";
export const darkBlueShadeColor = "#1a202c";
export const cloudyIndigoColor = "#64748b";
export const lightWhiteColor = "#f5f7ff";
export const blueishWhiteColor = "#f9fafb";
export const yellowishWhiteColor = "#fafcff";
export const yellowishWhiteLowShadeColor = "#f8f9fa";
export const lightWhiteFadeColor = "#f0f4ff";
export const blueFadeColor = "#4861dfff";
export const slightBluishTintColor = "#6b7280";
export const blackFade = "#444";
export const yellowishWhite = "#fff3cd";
export const redFade = "#d84315";
export const lightRedFade = "#ff4d4f";
export const marroon = "#c62828";
export const lightMarroon = "#fdebee";
export const lightWhiteRedShade = "#fafafa";
export const lightBrownColor = "#aaa";
export const blackishGrayColor = "#222";
export const grayShadeLightColor = "#888";
export const lightOrageColor = "#f5dc9e";
export const blueWhiteShade = "#374151";
export const blueBlackShade = "#111827";
export const slightSoftWhiteBlueShade = "#e0f2fe";
export const greenishBlueShade = "#e0f2fe";
export const greenShade = "#16a34a";
export const slightOrange = "#d97706";
export const slightRed = "#dc2626";
export const slightBlueishWhite = "#dbeafe";
export const darkBlueShade = "#1d4ed8";
export const lightGreenShade = "#dcfce7";
export const lightYellowShade = "#fef9c3";
export const lightRedShade = "#fee2e2";
export const strongOrangeColor = "#a16207";
export const strongGreenColor = "#15803d";
export const whiteShadeColor = "#f8fafc";
export const whiteStrongShadeColor = "#e5e7eb";
export const strongBlue = "#185FA5";
export const whiteBlueShade = "#E6F1FB";
export const strongBlack = "#333";
export const greyStrongColor = "#7a7a7a";
export const fadeViolet = "#6366f1";
export const fadeBlueWhite = "#e2e8f0";
export const whiteFadeShade = "#e0f0ff";
export const blueStrongShade = "#0369a1";
export const redFadeWhite = "#f5f5f5";
export const greenShadeColor = "#22c55e";
export const orangeFade = "#f59e0b";
export const redStrongColor = "#ef4444";
export const strongGreenColorShade = "#166534";
export const redShadeStrong = "#991b1b";
export const brownStrong = "#854d0e";
export const whiteSlightBlue = "#f3f4f6";
export const darkBlueStrong = "#1e40af";
export const strongBrown = "#92400e";
export const lightBlueShade = "#fef3c7";
export const lightWhiteRedShadeColor = "#f7f7f7";
export const lightSoftWhiteFaded = "#EBF3FB";
export const blueDarkFades = "#0C447C";
export const softYellowWhiteFade = "#EAF3DE";
export const greenDarkShade = "#27500A";
export const whiteLightShade = "#E5E7EB";
export const softRedShade = "#FDE2E2";
export const softRedShadev2 = "#FEF0F0";
export const redStyleShade = "#E24B4A";

// Status — closed
export const closedBgColor = "#E8F5E3";
export const closedTextColor = "#1B4D06";
export const closedDotColor = "#52A614";

// Status — active
export const activeBgColor = "#FFF4E0";
export const activeTextColor = "#5C3208";
export const activeDotColor = "#C07A10";

// Status — overdue
export const overdueBgColor = "rgb(255, 242, 242)";
export const overdueTextColor = "#e43636";
export const overdueDotColor = "#ff5364";

// Text hierarchy
export const textPrimaryColor = "#0F172A";
export const textSecondaryColor = "#475569";
export const textMutedColor = "#6B7A99";
export const textMutedSubtitleColor = "#334155";

// Surfaces / backgrounds
export const pageBgColor = "#F5F4F0";
export const surfaceAltColor = "#F9F8F6";
export const borderColor = "#E8E5DD";
export const borderLightColor = "#F0EDE6";

// Metric text colors
export const metricGreenColor = "#1A6B24";
export const metricAmberColor = "#8B4A08";
export const metricRedColor = "#921F1F";
export const metricBlueColor = "#0D4A8C";

// Bar fill colors
export const barGreenColor = "#52A614";
export const barAmberColor = "#C07A10";
export const barRedColor = "#DC3545";

// Tag — green
export const tagGreenBgColor = "#E8F5E3";
export const tagGreenTextColor = "#1B4D06";

// Tag — amber
export const tagAmberBgColor = "#FFF4E0";
export const tagAmberTextColor = "#7A3E00";

// Tag — red
export const tagRedBgColor = "#fff5f5";
export const tagRedTextColor = "#eb4343";

// Tag — blue
export const tagBlueBgColor = "#E0EFFF";
export const tagBlueTextColor = "#0D3B7A";

// Tag — purple
export const tagPurpleBgColor = "#EEF0FF";
export const tagPurpleTextColor = "#35308A";

// Tag — gray
export const tagGrayBgColor = "#F1EFE8";
export const tagGrayTextColor = "#4A4845";

// Tag — brown
export const tagBrownBgColor = "#FDF2E9";
export const tagBrownTextColor = "#8B4513";

// Alert — danger
export const dangerBgColor = "#FFF0F0";
export const dangerBorderColor = "#FFBBBB";
export const dangerTextColor = "#7B1111";
export const dangerDotColor = "#EF4444";

// Alert — warning
export const warnBgColor = "#FFFBF0";
export const warnBorderColor = "#FFD98A";
export const warnTextColor = "#6B3B00";
export const warnDotColor = "#F59E0B";

// Accent
export const accentColor = "#2563EB";
export const accentLightColor = "#EFF6FF";

// Timeline & misc
export const timelinePendingBgColor = "#F1EFE8";
export const timelinePendingBorderColor = "#C7C5BC";
export const timelineClosedBgColor = "#EFF6FF";
export const timelineLineNeutralColor = "#E2E0D8";
export const metricBarBgColor = "#E5E3DC";

// Details / icon circle
export const iconCircleColor = "#378ADD";

// Challan card open-border
export const challanOpenBorderColor = "#B6C8DC";

// Insights dot
export const insightsDotColor = "#1fbd00";
export const lightGreenShadeFaded = "#A8D5A2";
export const lightGreenishWhite = "#EAF5E3";
export const bluishWhiteShade = "#A8C4E8";
export const redOrangeShade = "#F5AAAA";
export const redDarkShade = "#C0152A";
export const grayShade = "#6B7280";
export const greenishFade = "#3B6D11";
export const lightYellowFaded = "#B4B2A9";

// Challan card closed-border
export const challanClosedBorderColor = "#B6C8DC";
// ─── Added for ChallanSettlementStyles (challan module) ──────────────────────

// Teal / green-teal family
export const tealDark = "#0F5345"; // teal section dark header
export const tealMid = "#1D9E75"; // teal mid / success green
export const tealMidLight = "#0D9488"; // icon inner teal / success icon
export const tealLightBg = "#EAF7F2"; // teal light icon bg
export const tealPaleBg = "#F0FBF6"; // cleared result bar background
export const tealPaleBorder = "#6DCFAD"; // cleared result bar border / card border
export const tealMintBg = "#CCFBF1"; // success modal icon ring background
export const tealFadeBg = "#F0FDF9"; // success modal okLight background

// Green family (stock / sign-off done state)
export const challanGreenDark = "#1A4D0A"; // stock section dark / done pill text
export const challanGreenBorder = "#67C48E"; // done pill border / flag ok border
export const challanGreenBg = "#EDF7E3"; // done pill bg / badge cleared bg

// Amber / orange family (payment section)
export const challanAmberDark = "#633806"; // amber dark / pending pill text / hold btn text
export const challanAmberMid = "#C07A14"; // pending pill dot / amber mid
export const challanAmberBorder = "#F5C060"; // pending pill border / hold btn border / flag warn border
export const challanAmberBg = "#FEF3DC"; // pending pill bg / hold btn bg / flag warn bg
export const challanAmberFlag = "#EF9F27"; // flag warn border (slightly brighter)

// Indigo / violet family (outstanding dues / on-hold state)
export const challanIndigoDark = "#3730A3"; // indigo dark / on-hold text
export const challanIndigoMid = "#6366F1"; // indigo mid (already fadeViolet, re-exported alias)
export const challanIndigoBg = "#EEF2FF"; // indigo light bg / hold result bar bg
export const challanIndigoBorder = "#A5B4FC"; // on-hold border / hold result bar border

// Red / error family (damage section / bounced)
export const challanRedDark = "#7C1D1D"; // red dark / bounced badge bg / bounced text deep
export const challanRedMid = "#791F1F"; // bounced result bar text (near-same as redDark)
export const challanRedBg = "#FFF2F2"; // bounced result bar background
export const challanRedBgAlt = "#FFF5F5"; // row error background (slightly lighter)
export const challanRedSoft = "#F5AAAA"; // bounced border / remove btn border
export const challanRedSoftBg = "#FEF0F0"; // remove btn bg (already softRedShadev2, alias)

// Blue / primary family (challan header / info)
export const challanBlueMid = "#378ADD"; // primary mid blue / add cheque btn border
export const challanBlueBg = "#EBF4FF"; // primary light / add cheque btn bg
export const challanBlueInfoBorder = "#85B7EB"; // invoice tag border / flag info border

// Neutral / surface family
export const challanSurfaceCard = "#F8FAFC"; // cheque fields box bg (same as whiteShadeColor)
export const challanSurfaceDeep = "#FAFBFD"; // signoff textarea bg / signatures card bg
export const challanBorderSoft = "#F0F2F5"; // cheque fields box border / signer divider
export const challanBorderCard = "#E8ECF2"; // signatures card border
export const challanBorderInput = "#D1D5DB"; // disabled input border / hold icon border
export const challanBorderForm = "#D1D9E6"; // signoff textarea / form input border
export const challanHeaderTableBg = "#EEF2F7"; // table thead background
export const challanRowDiffBg = "#FFFBF0"; // table row with difference background
export const challanSigHeaderBg = "#F4F6FA"; // signatures card header/footer background

// Text / label family
export const challanTextDeep = "#1A2332"; // signer name / deep body text
export const challanTextMuted2 = "#8A94A6"; // signer sub / placeholder-level muted
export const challanTextMuted3 = "#9CA3AF"; // ref label / disabled state text
export const challanTextSlate = "#4A5568"; // signoff field label
export const challanDisabledBg = "#C8D0DC"; // submit btn disabled background

// Success modal blue
export const challanModalBlue = "#1A56DB"; // done btn gradient start
export const challanModalBlueDark = "#1345B7"; // done btn gradient end

// Gradient stops for submit btn (challan green)
export const challanSubmitGreenDark = "#0F5E49"; // submit btn gradient dark stop
export const challanSubmitGreenMid = "#16A87A"; // submit btn gradient light stop

// Badge alpha overlay (semi-transparent on dark header)
export const challanBadgeOverlay = "#e2e2e24a";
export const bludDarkFadeShade = "#083260";
export const fadeWhiteShade = "#F0F6FF";
export const greenLimeLight = "#2E9E6B";
export const greenLimeLightv1 = "#3AAA72";
export const chocolateLight = "#4A2A04";
export const violetLight = "#1E1B6E";
export const greenLightLime = "#039639";
export const grayShadeWithSoftBlue = "#94a3b8";
// Search / input borders
export const secondaryMainColor = "#0f3f6f";
export const slateBorderHoverColor = "#cbd5e1";
export const defaultInputBorderColor = "#ccc";

// Challan card — action button colors
export const challanEditIconColor = "#60afff";
export const challanEditIconBgColor = "#afd1ff";
export const challanEditDisabledBgColor = "#e1efff";
export const challanEditDisabledBorderColor = "#f6faffa1";
export const challanCancelIconColor = "#ff9797";
export const challanCancelIconBgColor = "#ffe7e7";
export const challanCancelDisabledBgColor = "#fff4f4";
export const challanSettlementDisabledBorderColor = "#d6e3f4";
export const challanSettlementDisabledBgColor = "#f1f8ff";
export const challanExcelIconColor = "#75dc6e";
export const challanExcelIconBgColor = "#b6edd1";

// Challan SVG icon colors
export const challanSvgCancelCircleBg = "#FEF2F2";
export const challanSvgEditAccentStroke = "#BFDBFE";
export const challanSvgBillCircleBg = "#EEF0F8";
export const challanSvgBillDarkFill = "#1E3A5F";
export const challanSvgBillLineStroke = "#93C5FD";
export const challanSvgDeleteFill = "#FECACA";
export const challanSvgExcelCircleBg = "#F0FDF4";
export const challanSvgExcelAccentFill = "#BBF7D0";
export const challanSvgAvatarCircleBg = "#1565C0";

// Stock reconciliation — details view button
export const challanDetailsViewBtnBorderColor = "#C7D2FE";

// Validation modal colors
export const validationModalBlueLightColor = "#EEF4FF";
export const validationModalWarnLightColor = "#FFFBEB";
export const validationModalErrBorderColor = "#FCA5A5";
export const validationModalOkBorderColor = "#A7F3D0";
export const validationModalWarnBorderColor = "#FDE68A";
export const validationModalBackdropColor = "rgba(17,24,39,0.55)";

// ─── Advance Outlet Invoicing module ─────────────────────────────────────────
export const strongBlueDark = "#134d87";
export const lightRedPaleBg = "#fef2f2";
export const lightRedPaleBgV2 = "#f9aaab";
export const emeraldGreen = "#059669";
export const emeraldGreenPaleBg = "#ecfdf5";
export const slatePaleBg = "#f1f5f9";
export const outletInvoicingShadowColor = "rgba(15, 23, 42, 0.06)";
export const outletInvoicingPrimaryShadow = "rgba(24, 95, 165, 0.25)";
export const outletInvoicingPrimaryShadowHover = "rgba(24, 95, 165, 0.3)";
export const outletInvoicingDialogShadow = "rgba(15, 23, 42, 0.18)";
export const outletInvoicingCardShadow = "rgba(15, 23, 42, 0.07)";
export const outletInvoicingFocusRingShadow = "rgba(3, 105, 161, 0.12)";
export const outletInvoicingWhiteMuted = "rgba(255, 255, 255, 0.75)";
export const outletInvoicingSelectedRingShadow = "rgba(24, 95, 165, 0.1)";
export const outletInvoicingSelectedGradientStart = "#f0f7ff";
export const outOfStockColor = "#FFaaaa";

export const slateTextColor = "#1e293b";
export const softBlueBorderColor = "#dbe3ee";
export const softBlueLineColor = "#e8edf2";
export const softBlueSelectedBg = "#e8f1fb";
export const softBlueSelectedHover = "#d7e7f8";
export const checkboxFocusRingColor = "rgba(25, 118, 210, 0.14)";
export const textPrimaryMenuShadowColor = "rgba(15, 23, 42, 0.1)";
